import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import getDecodedToken from "services/getDecodedToken";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import {
  PageContainer, PremiumCard, FormSection, Field, SelectField, Button,
} from "components/ui";

const AddDemande = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [id, setId] = useState();
  const [nbrJours, setNbrJours] = useState();
  const [holidays, setHolidays] = useState([]);

  const [firstDate, setFirstDate] = useState("");
  const [lastDate, setLastDate] = useState("");
  const [motif, setMotif] = useState("");
  const [status, setStatus] = useState("Normal");
  const [error, setError] = useState("");
  const [error2, setError2] = useState("");

  const fetchUserByEmail = async (email) => {
    try {
      const response = await axiosPrivate.get("/user/getU", { params: { email } });
      setId(response.data.user_id);
      setNbrJours(response.data.nbrJours);
    } catch (_) {
      console.error("User not found");
    }
  };
  const fetchHolidays = async () => {
    try {
      const res = await axiosPrivate.get("/holiday/all");
      setHolidays(res.data);
    } catch (_) {}
  };

  useEffect(() => {
    const decoded = getDecodedToken();
    if (decoded) setEmail(decoded.sub);
    if (email) { fetchUserByEmail(email); fetchHolidays(); }
  }, [email]);

  const handleDateChange = (setter, setErr) => (e) => {
    const d = new Date(e.target.value);
    const day = d.getDay();
    if (day === 0 || day === 6) {
      setErr("Weekends are not allowed. Please select a weekday.");
      setter("");
    } else {
      setErr("");
      setter(e.target.value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const date1 = new Date(firstDate);
    const date2 = new Date(lastDate);
    const diffDays = Math.ceil(Math.abs(date2 - date1) / 86400000);
    const isHoliday = holidays.some((h) => h === lastDate || h === firstDate);
    if (isHoliday) {
      alert("Holidays are not allowed. Try other dates.");
      return;
    }
    holidays.forEach((h) => {
      if (h > firstDate && h < lastDate) {
        alert("Holidays shouldn't be included in your period");
      }
    });
    try {
      if (diffDays < nbrJours && date1 <= date2) {
        await axiosPrivate.post("/demande/add", {
          dateDebut: firstDate, dateFin: lastDate, motif, status,
        });
        alert("Demand added successfully!");
        navigate("/myDemands");
      } else {
        alert("Number of days between dates must be less than your days count.");
      }
    } catch {
      alert("Error occurred!");
    }
  };

  return (
    <PageContainer narrow>
      <PremiumCard title="New demand" subtitle={`Available days: ${nbrJours ?? "—"}`}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gap: 24 }}>
            <FormSection title="Details" columns={2}>
              <Field label="Motif" value={motif} onChange={(e) => setMotif(e.target.value)} placeholder="Reason for the demand…" />
              <SelectField label="Status" value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="Normal">Normal</option>
                <option value="Urgente">Urgente</option>
                <option value="Très urgente">Très urgente</option>
              </SelectField>
            </FormSection>
            <FormSection title="Period" columns={2}>
              <Field label="First date" required type="date" value={firstDate} onChange={handleDateChange(setFirstDate, setError)} error={error} />
              <Field label="Last date"  required type="date" value={lastDate}  onChange={handleDateChange(setLastDate, setError2)}  error={error2} />
            </FormSection>
          </div>

          <div className="form-actionbar">
            <Button type="submit" variant="primary">Submit demand</Button>
          </div>
        </form>
      </PremiumCard>
    </PageContainer>
  );
};

export default AddDemande;
